import { use, useEffect, useRef, useState } from "react";
import {
  Arrow,
  BtnSwap,
  Button,
  ButtonCloseModal,
  ButtonPaymentModal,
  ButtonSaveFileModal,
  CloseButton,
  DiscountBox,
  DocumentNoteCounter,
  DocumentNoteDesc,
  DocumentNoteFooter,
  DocumentNoteHeader,
  DocumentNoteHint,
  DocumentNoteTextarea,
  DocumentNoteTitle,
  DocumentNoteWrapper,
  FeatureContent,
  FeatureH4,
  FeatureIcon,
  FeatureItem,
  FeatureP,
  Features,
  FileActions,
  FileHeader,
  FileIcon,
  FileInfo,
  FileInfoCard,
  FileItem,
  FileName,
  FilePreview,
  FileSize,
  FormGroup,
  Hero,
  HeroDescription,
  HeroTitle,
  Label,
  LanguageRow,
  LoadingButtonContent,
  LoadingText,
  NewPrice,
  OldPrice,
  PercentText,
  PreviewButton,
  PreviewCanvas,
  PreviewContent,
  PreviewFooter,
  PreviewHeader,
  PreviewModal,
  PreviewOverlay,
  PreviewOverlayPreview,
  PreviewTitle,
  PriceTag,
  PrimaryButton,
  ProcessText,
  RadioButton,
  RemoveButton,
  SectionDescription,
  SectionHeader,
  SectionMain,
  SectionTitle,
  Select,
  SelectArrow,
  SelectWrapper,
  Spinner,
  SpinnerWrapper,
  SubProcessText,
  TabButton,
  Tabs,
  TextArea,
  UploadArea,
  UploadButton,
  WaveProgressWrapper,
  WaveTitle,
  ProcessModal,
  ProcessFileCard,
  ProcessFileExt,
  ProcessLoader,
  ProcessTip,
  FileBlock,
  UploadedFileCard,
  UploadedFileIcon,
  UploadedFileMeta,
  UploadedFileName,
  UploadedFileSize,
  UploadedFileActions,
  UploadedPreviewButton,
  UploadedDeleteButton,
  ToneSectionTitle,
  ToneListCard,
  ToneChoice,
  ToneChoiceIcon,
  ToneChoiceText,
  ToneAnimatedWrapper,
  TranslationModeOption,
  TermsAgreementBox,
  TermsAgreementLabel,
  TermsAgreementIcon,
  TermsText,
  TranslateNowButton,
  TranslationModeGrid,
} from "../../style/AIToolsPage_Style";
import { Note, UploadIcon, UploadSvg } from "./StyledFileTranslatePage";
import { ITokenPayload } from "../../models/user";
import { jwtDecode } from "jwt-decode";
import TranslateService from "../../services/api/translate.service";
import { toast } from "../../utils/notify";
import {
  connectSignal,
  getSignalConnection,
} from "../../services/api/signalr.Service";
import pdfjsLib from "../../pdfConfig";
import { useStore } from "../../zustand";
import PaymentService from "../../services/api/payment.service";
import { EQrcodeRequest } from "../../models/payment";
import { Helmet } from "react-helmet-async";
import SeoService from "../../services/api/seo.service";
import { ECommonPageSeo, EContentResponse } from "../../models/seo";
import FAQ from "../../components/FAQ";
import { Trans, useTranslation } from "react-i18next";
import { envConfig } from "../../config/env.config";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import ToneService from "../../services/api/tone.service";
import { ToneItem } from "../../models/tone";
import VisitService from "../../services/api/visit.service";
import { IVisitRequest } from "../../models/visit";
import { Box, InputAdornment, TextField } from "@mui/material";
import DiscountService from "../../services/api/discount.service";
import { DiscountCodeRq } from "../../models/discount";
import mammoth from "mammoth";
import * as XLSX from "xlsx";
import JSZip from "jszip";

export enum EPaymentStatus {
  pending,
  success,
  translate_Processing,
  translate_Completed,
  failed,
  delete,
  free,
}

export enum EnumPdfType {
  //Full_Img = 0,
  Only_Text = 1,
  Text_Or_Image = 2,
}

export type UploadFile = {
  id: string;
  file?: File;
  fileSize?: number;
  progress: number;
  isTranslating: boolean;
  status: EPaymentStatus;
  price?: number;
  fileBase64?: string;
  previewBase64?: string;
  fileName?: string;
  orderId: string;
  totalCharacters?: number;
  numberOfTranslationServicesUsed?: number;
  totalNumberOfTranslationServicesUsed?: number;
};

export type HistoryTranslate = {
  id: string;
  fileName: string;
  fileSize: number;
  status: EPaymentStatus;
  orderId: string;
  totalCharacters: number;
  price: number;
  from: string;
  to: string;
  userId: string;
  fileDownloadBase64: string;
  filePreviewBase64: string;
  fileOriginal?: string;
  expirationDate: Date;
  createdDate: Date;
  numberOfTranslationServicesUsed?: number;
  totalNumberOfTranslationServicesUsed?: number;
  isDownload: boolean;
};

export const languages = [
  // Major
  { code: "en", label: "English" },
  { code: "vi", label: "Vietnamese" },
  { code: "zh-Hans", label: "Chinese (Simplified)" },
  { code: "zh-Hant", label: "Chinese (Traditional)" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },

  // European
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "es", label: "Spanish" },
  { code: "it", label: "Italian" },
  { code: "pt", label: "Portuguese" },
  { code: "pt-BR", label: "Portuguese (Brazil)" },
  { code: "ru", label: "Russian" },
  { code: "nl", label: "Dutch" },
  { code: "pl", label: "Polish" },
  { code: "uk", label: "Ukrainian" },
  { code: "cs", label: "Czech" },
  { code: "sk", label: "Slovak" },
  { code: "hu", label: "Hungarian" },
  { code: "ro", label: "Romanian" },
  { code: "el", label: "Greek" },
  { code: "sv", label: "Swedish" },
  { code: "no", label: "Norwegian" },
  { code: "da", label: "Danish" },
  { code: "fi", label: "Finnish" },

  // Southeast Asia
  { code: "th", label: "Thai" },
  { code: "id", label: "Indonesian" },
  { code: "ms", label: "Malay" },
  { code: "km", label: "Khmer" },
  { code: "lo", label: "Lao" },
  { code: "my", label: "Burmese" },
  { code: "fil", label: "Filipino" },

  // South Asia
  { code: "hi", label: "Hindi" },
  { code: "bn", label: "Bengali" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "ur", label: "Urdu" },
  { code: "si", label: "Sinhala" },
  { code: "ne", label: "Nepali" },

  // Middle East
  { code: "ar", label: "Arabic" },
  { code: "fa", label: "Persian (Farsi)" },
  { code: "he", label: "Hebrew" },
  { code: "tr", label: "Turkish" },

  // Africa
  { code: "sw", label: "Swahili" },
  { code: "af", label: "Afrikaans" },
  { code: "am", label: "Amharic" },
  { code: "ha", label: "Hausa" },
  { code: "yo", label: "Yoruba" },
  { code: "zu", label: "Zulu" },

  // Others
  { code: "is", label: "Icelandic" },
  { code: "ga", label: "Irish" },
  { code: "mt", label: "Maltese" },
  { code: "lb", label: "Luxembourgish" },
];

const toneStyleTypes = [
  "friendly",
  "inspiring",
  "neutral",
  "professional",
  "formal",
] as const;

const toneIcons = ["☺", "♡", "⚖", "▣", "♜"] as const;

const TERMS_STORAGE_KEY = "translate.acceptedTerms";

const getAcceptedTermsFromStorage = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(TERMS_STORAGE_KEY) === "1";
};

const AiToolsPage = () => {
  const { t, i18n } = useTranslation();

  const [tab, setTab] = useState<"translate" | "file" | "compress">("file");
  const [files, setFiles] = useState<UploadFile[]>([]);

  const [fromLang, setFromLang] = useState("vi");
  const [toLang, setToLang] = useState("en");
  const [isTranslating, setIsTranslating] = useState(false);
  // Loading riêng khi browser đang đọc nội dung file để đếm ký tự.
  const [isCountingCharacters, setIsCountingCharacters] = useState(false);
  // Khóa đồng bộ luồng thêm file cho cả chọn file và kéo-thả.
  // Dùng ref để chặn click/drop liên tiếp trước khi React kịp re-render.
  const isAddingFileRef = useRef(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const signalInitedRef = useRef(false);
  const [user, setUser] = useState<ITokenPayload | null>();
  const [isDragging, setIsDragging] = useState(false);
  const [text, setText] = useState<string>();
  const [language, setLanguage] = useState<string>("VI");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [showPdfTypeModal, setShowPdfTypeModal] = useState(false);
  const [pdfType, setPdfType] = useState<EnumPdfType>(EnumPdfType.Only_Text);
  // Áp dụng cho DOC, DOCX, XLSX, PPTX và PDF.
  // true: dịch miễn phí, false: dịch trả phí.
  const [isFree, setIsFree] = useState<boolean>(true);
  const [tones, setTone] = useState<ToneItem[]>([]);
  const [toneId, setToneId] = useState<string>();
  const [isRenderingPreview, setIsRenderingPreview] = useState(false);
  const [discountCode, setDiscountCode] = useState("");
  const [discountApplied, setDiscountApplied] = useState(false);
  const [isApplyingDiscount, setIsApplyingDiscount] = useState(false);
  const [isCancellingTranslation, setIsCancellingTranslation] = useState(false);

  // Khi user chủ động hủy, bỏ qua SignalR Completed/Failed về trễ của job cũ.
  const cancelRequestedRef = useRef(false);

  const MAX_UPLOAD_FILE_SIZE_MB = 50;
  const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

  // File lớn hơn 10MB bắt buộc dùng chế độ trả phí.
  const FREE_TRANSLATION_MAX_FILE_SIZE_MB = 10;
  const FREE_TRANSLATION_MAX_FILE_SIZE_BYTES =
    FREE_TRANSLATION_MAX_FILE_SIZE_MB * 1024 * 1024;

  // File Office vượt quá 10.000 ký tự bắt buộc dùng chế độ trả phí.
  const FREE_TRANSLATION_MAX_CHARACTERS = 30000;

  // Chỉ dùng để cảnh báo người dùng khi nội dung file vượt 1.000 ký tự.
  const CHARACTER_WARNING_LIMIT = 30000;

  const [showFileSizeModal, setShowFileSizeModal] = useState(false);
  const [rejectedLargeFile, setRejectedLargeFile] = useState<File | null>(null);

  // Modal cảnh báo file vượt quá giới hạn 10.000 ký tự dịch miễn phí.
  // File vẫn được giữ lại và hệ thống tự chuyển sang chế độ trả phí.
  const [showCharacterLimitModal, setShowCharacterLimitModal] = useState(false);
  const [characterLimitFile, setCharacterLimitFile] = useState<File | null>(
    null,
  );
  const [characterLimitCount, setCharacterLimitCount] = useState(0);

  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(() =>
    getAcceptedTermsFromStorage(),
  );
  const [previewFile, setPreviewFile] = useState<UploadFile | null>(null);

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const previewRenderTokenRef = useRef(0);
  const [commonPageSeo, setCommonPageSeo] = useState<ECommonPageSeo>();

  const data = useStore((s) => s.data);

  const getDataContent = async (langParam?: string) => {
    const lang = (langParam ?? i18n.language)?.toUpperCase();
    const res = await SeoService.getCommonPageSeo("Homepage", i18n.language);
    const resTone = await ToneService.getAll(i18n.language);

    if (res.success && res.data) {
      setCommonPageSeo(res.data);
    }
    if (resTone.success) {
      setTone(resTone.data);
      setToneId(resTone.data[0]?.id);
    }

    setLanguage(lang);
  };

  const createVisit = async () => {
    const data: IVisitRequest = {
      page: "Homepage",
      userAgent: navigator.userAgent,
    };

    await VisitService.create(data);
  };

  useEffect(() => {
    getDataContent(i18n.language);
    createVisit();
  }, [i18n.language, data]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<any>(token);

      const user: ITokenPayload = {
        ...decoded,
        isAdmin: decoded.isAdmin === true || decoded.isAdmin === "True",
      };
      setUser(user);
    } else {
      setUser(null);
    }
  }, [data]);

  const getProcessText = () => t("translate.ai_processing");

  const getFileExt = (fileName?: string) =>
    fileName ? `.${fileName.split(".").pop()?.toLowerCase()}` : "";

  const hasPdfFile = () =>
    files.some((f) => getFileExt(f.file?.name || f.fileName) === ".pdf");

  const hasOfficeFile = () =>
    files.some((f) =>
      [".doc", ".docx", ".xlsx", ".pptx"].includes(
        getFileExt(f.file?.name || f.fileName),
      ),
    );

  // Office + PDF đều hỗ trợ lựa chọn miễn phí / trả phí.
  const hasTranslationModeFile = () => hasOfficeFile() || hasPdfFile();

  const isFileOverFreeLimit = (file?: UploadFile) => {
    const size = file?.file?.size ?? file?.fileSize ?? 0;
    const totalCharacters = file?.totalCharacters ?? 0;

    return (
      size > FREE_TRANSLATION_MAX_FILE_SIZE_BYTES ||
      totalCharacters > FREE_TRANSLATION_MAX_CHARACTERS
    );
  };

  const hasFileOverFreeLimit = () => files.some(isFileOverFreeLimit);

  const handleCreate = async (selectedPdfType: EnumPdfType = pdfType) => {
    cancelRequestedRef.current = false;
    setIsCancellingTranslation(false);

    const formData = new FormData();
    formData.append("FolderName", "Translate-" + user?.fullName);
    if (files.length > 0) {
      setShowProcessModal(true); // 👈 mở modal process

      files.map((f) => {
        f.file && formData.append("Files", f.file); // 👈 thêm từng file
        formData.append("FileIds", f.id);
      });

      // cancelKey dùng đúng UUID của file ở frontend.
      // Backend cũng có thể lấy trực tiếp từ FileIds; field này thêm để debug/forward dễ hơn.
      if (files[0]?.id) {
        formData.append("CancelKey", files[0].id);
      }

      formData.append("From", fromLang); // 👈 thêm từng file
      formData.append("To", toLang); // 👈 thêm từng file
      toneId && formData.append("ToneId", toneId); // 👈 thêm từng file
      // Nếu là PDF thì gửi kiểu xử lý PDF xuống API.
      // Backend nhận theo enum C#: EnumPdfType { Full_Img = 0, Only_Text = 1, Text_Or_Image = 2 }
      if (hasPdfFile()) {
        formData.append("PdfType", selectedPdfType.toString());
      }

      // DOC, DOCX, XLSX, PPTX và PDF đều gửi lựa chọn miễn phí/trả phí.
      // Backend nhận property bool isFree.
      if (hasTranslationModeFile()) {
        formData.append("isFree", isFree.toString());
      }

      //await UploadFileService.uploadFile(formData).then(async (response) => {
      //   if (response.success) {
      //     const data = response.data[0];

      //const path = envConfig.MEDIA_ENDPOINT + data.path;

      // const request: ITranslateRequest = {
      //   FilePath: path,
      //   FileName: data.fileName,
      //   From: fromLang,
      //   To: toLang,
      // };
      setFiles((prev) =>
        prev.map((f, i) =>
          i === 0 ? { ...f, isTranslating: true, progress: 0 } : f,
        ),
      );

      setIsTranslating(true);

      try {
        await TranslateService.create(formData);
      } catch (error) {
        toast(t("error.translate_fail"), "error");
        setShowProcessModal(false);
        setIsTranslating(false);
        setFiles((prev) =>
          prev.map((f) => ({ ...f, isTranslating: false, progress: 0 })),
        );
      }
      // toggleMessage({
      //   type: "success",
      //   message: resTranslateOfficeFile?.message ?? ""
      // });
    } else {
      toast(t("error.upload_fail"), "error");
    }
    // });
    // } else {
    //   toast("❌ Vui lòng tải lên file cần dịch", "error");
    // }
  };

  const clearPreviewContainer = () => {
    const container = document.getElementById("pdf-preview-container");
    if (container) container.innerHTML = "";
  };

  const openPreviewLoading = () => {
    previewRenderTokenRef.current += 1; // hủy render cũ nếu còn chạy
    clearPreviewContainer();
    setPreviewFile(null); // clear data modal cũ trước khi mở modal mới
    setIsRenderingPreview(true); // bật loading ngay, không chờ useEffect renderPdf
    setShowPreviewModal(true);
  };

  const closePreviewModal = () => {
    previewRenderTokenRef.current += 1; // chặn async render cũ append canvas sau khi đóng
    setShowPreviewModal(false);
    setIsRenderingPreview(false);
    setPreviewFile(null);
    getDataContent(i18n.language);
    setTimeout(clearPreviewContainer, 0);
  };

  useEffect(() => {
    let conn;

    const initSignalR = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      conn = await connectSignal(token);

      conn.on("TranslateCompleted", async (data: HistoryTranslate) => {
        // Job cũ có thể hoàn tất đúng lúc user vừa bấm Hủy.
        // Không mở preview/file kết quả của job đã bị user bỏ.
        if (cancelRequestedRef.current) {
          return;
        }

        setShowProcessModal(false); // 👈 đóng modal process

        setFiles((prev) =>
          prev.map((f) =>
            f.id === data.id
              ? {
                  ...f,
                  isTranslating: false,
                  progress: 100,
                  status: data.status,
                  price: data.price,
                  orderId: data.orderId,
                  previewBase64: data.filePreviewBase64,
                  fileBase64: data.fileDownloadBase64,
                  fileName: data.fileName,
                  numberOfTranslationServicesUsed:
                    data.numberOfTranslationServicesUsed,
                  totalNumberOfTranslationServicesUsed:
                    data.totalNumberOfTranslationServicesUsed,
                }
              : f,
          ),
        );

        openPreviewLoading();
        const previewRequestToken = previewRenderTokenRef.current;

        try {
          // 🔥 TỰ ĐỘNG MỞ PREVIEW MODAL
          const filePreview = await TranslateService.getFilePreview(
            data.orderId,
          );

          if (previewRequestToken !== previewRenderTokenRef.current) return;
          setPreviewFile({
            id: filePreview.data.id,
            file: new File([], filePreview.data.fileName), // dummy file
            status: filePreview.data.status,
            progress: 100,
            isTranslating: false,
            fileSize: filePreview.data.fileSize,
            orderId: filePreview.data.orderId,
            price: filePreview.data.price,
            previewBase64: buildPreviewImageUrl(
              filePreview.data.filePreviewBase64,
            ),
            fileBase64: filePreview.data.fileDownloadBase64,
            fileName: filePreview.data.fileName,
            numberOfTranslationServicesUsed:
              filePreview.data.numberOfTranslationServicesUsed,
            totalNumberOfTranslationServicesUsed:
              filePreview.data.totalNumberOfTranslationServicesUsed,
          });
        } catch (error) {
          console.error("Preview error:", error);
          closePreviewModal();
          toast(t("error.preview_fail") || t("error.translate_fail"), "error");
        }

        setFiles([]);

        setTimeout(() => {
          //downloadBase64File(data.fileBase64, data.fileName);
          setIsTranslating(false);

          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // ✅ reset input thật sự
          }
          return;
          //}
        }, 500);
      });

      conn.on("TranslateFailed", (data) => {
        if (cancelRequestedRef.current) {
          return;
        }

        toast(t("error.translate_fail"), "error");
        setShowProcessModal(false);
        setIsTranslating(false);
        setFiles([]);
      });

      conn.on("TranslateCancelled", () => {
        cancelRequestedRef.current = true;
        setShowProcessModal(false);
        setIsTranslating(false);
        setIsCancellingTranslation(false);
      });
    };

    initSignalR();

    return () => {
      const conn = getSignalConnection();
      conn?.off("TranslateCompleted");
      conn?.off("TranslateFailed");
      conn?.off("TranslateCancelled");
    };
  }, [data]);

  useEffect(() => {
    setFiles([]);
  }, [data]);

  useEffect(() => {
    const connection = getSignalConnection();
    if (!connection) {
      console.error("❌ No SignalR connection available");
      return;
    }

    // connection.on("TranslateFailed", (data) => {
    //   toast(t("error.translate_fail"), "error");
    //   setShowProcessModal(false);
    //   setIsTranslating(false);
    //   setFiles([]);
    // });
  }, []);

  const formatFileSizeMB = (size: number) => {
    return `${(size / 1024 / 1024).toFixed(2)} MB`;
  };

  const base64ToUrl = (base64: string) => {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) u8arr[n] = bstr.charCodeAt(n);

    const blob = new Blob([u8arr], { type: mime });
    return URL.createObjectURL(blob);
  };

  const handlePreviewFileModal = (uploadFile: UploadFile) => {
    openPreviewLoading();
    const previewRequestToken = previewRenderTokenRef.current;

    requestAnimationFrame(() => {
      if (previewRequestToken !== previewRenderTokenRef.current) return;
      setPreviewFile(uploadFile);
    });
  };

  const handleSwapLanguage = () => {
    setFromLang((prevFrom) => {
      setToLang(prevFrom);
      return toLang;
    });
  };

  // Đếm ký tự nội dung, giữ khoảng trắng thông thường nhưng bỏ xuống dòng/tab
  // để tránh tính thêm ký tự do cấu trúc file.
  const countTextCharacters = (value: string) => {
    return (value || "").replace(/[\r\n\t]/g, "").length;
  };

  const countDocxCharacters = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer });

    return countTextCharacters(result.value || "");
  };

  const countXlsxCharacters = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });

    let totalCharacters = 0;

    workbook.SheetNames.forEach((sheetName) => {
      const sheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json<any[]>(sheet, {
        header: 1,
        raw: false,
        defval: "",
      });

      rows.forEach((row) => {
        row.forEach((cell) => {
          if (cell !== null && cell !== undefined && cell !== "") {
            totalCharacters += countTextCharacters(String(cell));
          }
        });
      });
    });

    return totalCharacters;
  };

  const countPptxCharacters = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    const zip = await JSZip.loadAsync(arrayBuffer);

    const slideFiles = Object.keys(zip.files)
      .filter(
        (name) =>
          /^ppt\/slides\/slide\d+\.xml$/i.test(name) && !zip.files[name].dir,
      )
      .sort((a, b) => {
        const getSlideNumber = (name: string) =>
          Number(name.match(/slide(\d+)\.xml$/i)?.[1] || 0);

        return getSlideNumber(a) - getSlideNumber(b);
      });

    let totalCharacters = 0;

    for (const slideName of slideFiles) {
      const xml = await zip.files[slideName].async("text");
      const xmlDocument = new DOMParser().parseFromString(
        xml,
        "application/xml",
      );

      // Text trong PowerPoint nằm trong các node <a:t>.
      const textNodes = Array.from(
        xmlDocument.getElementsByTagNameNS("*", "t"),
      );

      textNodes.forEach((node) => {
        totalCharacters += countTextCharacters(node.textContent || "");
      });
    }

    return totalCharacters;
  };

  const countPdfCharacters = async (file: File) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    let totalCharacters = 0;

    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const textContent = await page.getTextContent();

      textContent.items.forEach((item: any) => {
        if (typeof item?.str === "string") {
          totalCharacters += countTextCharacters(item.str);
        }
      });
    }

    return totalCharacters;
  };

  const getFileCharacterCount = async (file: File) => {
    const ext = "." + file.name.split(".").pop()?.toLowerCase();

    try {
      switch (ext) {
        case ".docx":
          return await countDocxCharacters(file);

        case ".xlsx":
          return await countXlsxCharacters(file);

        case ".pptx":
          return await countPptxCharacters(file);

        case ".pdf":
          return await countPdfCharacters(file);

        // .doc là định dạng Word binary cũ, browser không đọc ổn định bằng Mammoth.
        // Backend nên đếm lại nếu anh vẫn cho phép upload .doc.
        case ".doc":
        default:
          return 0;
      }
    } catch (error) {
      console.error("Count file characters error:", error);
      return 0;
    }
  };

  const handleAddFile = async (file: File) => {
    if (!user) {
      toast(t("auth.login_required"), "info");
      return;
    }

    // Chặn thêm file mới khi đang đọc file, đang dịch, đã có file
    // hoặc một luồng add file khác đang chạy.
    if (
      isAddingFileRef.current ||
      isCountingCharacters ||
      isTranslating ||
      files.length > 0
    ) {
      return;
    }

    const countHistories = Math.max(
      (commonPageSeo?.seo?.totalNumberOfTranslationServicesUsed ?? 0) -
        (commonPageSeo?.seo?.numberOfTranslationServicesUsed ?? 0),
      0,
    );

    const allowExt = [".doc", ".docx", ".pptx", ".xlsx", ".pdf"];
    const ext = "." + file.name.split(".").pop()?.toLowerCase();

    // ==============================
    // CHECK FORMAT
    // ==============================
    if (!allowExt.includes(ext)) {
      toast(t("error.unsupported_format"), "error");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return;
    }

    // ==============================
    // CHECK MAX 50MB
    // ==============================
    if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      setRejectedLargeFile(file);
      setShowFileSizeModal(true);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return;
    }

    // Từ đây trở xuống, cả chọn file và kéo-thả đều dùng chung một flow.
    isAddingFileRef.current = true;
    setIsCountingCharacters(true);

    try {
      const totalCharacters = await getFileCharacterCount(file);

      const isOverFreeSizeLimit =
        file.size > FREE_TRANSLATION_MAX_FILE_SIZE_BYTES;

      const isOverFreeCharacterLimit =
        totalCharacters > FREE_TRANSLATION_MAX_CHARACTERS;

      // Bắt buộc trả phí khi:
      // 1. Hết lượt miễn phí.
      // 2. File > giới hạn dung lượng miễn phí.
      // 3. Nội dung > giới hạn ký tự miễn phí.
      //
      // PDF không còn bị ép trả phí:
      // PDF text-native vẫn có thể chọn isFree=true.
      // PDF scan/image nếu không có text sẽ được backend kiểm tra và báo phù hợp.
      const mustUsePaid =
        countHistories === 0 || isOverFreeSizeLimit || isOverFreeCharacterLimit;

      setIsFree(!mustUsePaid);

      setFiles([
        {
          id: crypto.randomUUID(),
          file,
          status: EPaymentStatus.pending,
          progress: 0,
          isTranslating: false,
          orderId: "",
          totalCharacters,
        },
      ]);

      // File vượt 10.000 ký tự:
      // - vẫn giữ file đã upload
      // - tự chuyển sang chế độ trả phí qua mustUsePaid ở phía trên
      // - hiển thị modal thay vì toast
      if (totalCharacters > CHARACTER_WARNING_LIMIT) {
        setCharacterLimitFile(file);
        setCharacterLimitCount(totalCharacters);
        setShowCharacterLimitModal(true);
      }
    } catch (error) {
      console.error("Read file error:", error);

      toast(
        t("file.read_file_error", {
          defaultValue: "Không thể đọc nội dung tệp. Vui lòng thử lại.",
        }),
        "error",
      );

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } finally {
      isAddingFileRef.current = false;
      setIsCountingCharacters(false);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (
      files.length > 0 ||
      isAddingFileRef.current ||
      isCountingCharacters ||
      isTranslating
    ) {
      return;
    }

    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = async (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (
      files.length > 0 ||
      isAddingFileRef.current ||
      isCountingCharacters ||
      isTranslating
    ) {
      return;
    }

    const file = e.dataTransfer.files?.[0];
    if (!file) return;

    // Không xử lý riêng ở drop. Toàn bộ validate/đếm ký tự/free-paid/toast
    // đều đi qua handleAddFile giống hệt nút Chọn file.
    await handleAddFile(file);
  };

  const handleGetQrcode = async () => {
    if (previewFile) {
      const data: EQrcodeRequest = {
        orderId: previewFile.orderId,
        price: previewFile.price ?? 0,
      };

      const qrcode = await PaymentService.GetQrCode(data);

      if (qrcode.success) {
        window.open(qrcode.data, "_blank");
      } else {
        toast(t("error.qr_fail"), "error");
      }
    } else {
      toast(t("error.qr_fail"), "error");
    }
  };

  const handleAcceptedTermsChange = (checked: boolean) => {
    setAcceptedTerms(checked);

    if (checked) {
      localStorage.setItem(TERMS_STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(TERMS_STORAGE_KEY);
    }
  };

  const formatVND = (value: number): string => {
    return new Intl.NumberFormat("vi-VN").format(value);
  };

  const createOrder = async (customOrderId?: string | null, price?: number) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "paypal_click",
    });

    const res = await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/create-order?customOrderId=${customOrderId}&price=${price}`,
      {
        method: "POST",
      },
    );

    if (!res.ok) {
      toast(t("payment.createFailed"), "error");
      return;
    }

    const data = await res.json();
    return data.id;
  };

  const onApprove = async (data: any, customOrderId?: string) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "purchase",
      transaction_id: data.orderID,
      value: data.price,
      currency: "USD",
      payment_method: "paypal",
      custom_order_id: customOrderId,
    });

    await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/capture-order?orderId=${data.orderID}&customOrderId=${customOrderId}`,
      { method: "POST" },
    );

    toast(t("payment.paypalSuccess"), "success");

    setShowPaymentModal(false);

    // cập nhật trạng thái file đã thanh toán
    setFiles((prev) =>
      prev.map((f) =>
        f.id === previewFile?.id ? { ...f, status: EPaymentStatus.success } : f,
      ),
    );

    envConfig.KEY_BASE === "vn"
      ? window.open(
          "https://docme.vn/transaction?orderId=" + customOrderId,
          "_blank",
        )
      : window.open(
          "https://docme.world/transaction?orderId=" + customOrderId,
          "_blank",
        );
  };

  const validTones = (tones || []).filter((t) => t && t.id && t.question);

  const processFile = files.find((f) => f.isTranslating) || files[0];

  const processFileName =
    processFile?.file?.name || processFile?.fileName || "Document";

  const processFileSize = processFile?.file?.size
    ? `${(processFile.file.size / 1024 / 1024).toFixed(2)} MB`
    : "";

  const processFileExt =
    processFileName.split(".").pop()?.toUpperCase() || "FILE";

  const handleCancelTranslation = async () => {
    if (!processFile || isCancellingTranslation) return;

    const cancelKey = processFile.id;
    const orderId = processFile.orderId || null;

    // Set trước khi gọi API để SignalR Completed về đúng lúc này cũng bị bỏ qua.
    cancelRequestedRef.current = true;
    setIsCancellingTranslation(true);

    try {
      const token = localStorage.getItem("token");
      const apiBase = envConfig.API_ENDPOINT.replace(/\/$/, "");

      const response = await fetch(`${apiBase}/translate/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          cancelKey,
          orderId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Cancel translation failed: ${response.status}`);
      }

      const result = await response.json().catch(() => null);

      if (result && result.success === false) {
        throw new Error(result.message || "Cancel translation failed");
      }

      // Đóng modal ngay sau khi backend đã nhận lệnh hủy.
      setShowProcessModal(false);
      setIsTranslating(false);
      setFiles([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      toast(
        t("translation.cancelled", {
          defaultValue: "Đã hủy quá trình dịch tệp.",
        }),
        "info",
      );
    } catch (error) {
      console.error("Cancel translation error:", error);

      // API hủy thất bại thì tiếp tục giữ modal + tiếp tục nhận Completed/Failed.
      cancelRequestedRef.current = false;

      toast(
        t("translation.cancelFailed", {
          defaultValue: "Không thể hủy quá trình dịch. Vui lòng thử lại.",
        }),
        "error",
      );
    } finally {
      setIsCancellingTranslation(false);
    }
  };

  const pdfTypeOptions = [
    {
      value: EnumPdfType.Only_Text,
      title: t("pdf.only_text.title"),
      desc: t("pdf.only_text.desc"),
    },
    {
      value: EnumPdfType.Text_Or_Image,
      title: t("pdf.text_or_image.title"),
      desc: t("pdf.text_or_image.desc"),
    },
    // {
    //   value: EnumPdfType.Full_Img,
    //   title: t("pdf.full_image.title"),
    //   desc: t("pdf.full_image.desc"),
    // },
  ];

  const handleTranslateClick = () => {
    if (!user) return toast(t("auth.login_required"), "info");
    if (!files.length) return toast(t("error.upload_fail"), "error");

    if (hasPdfFile()) {
      // PDF miễn phí:
      // Backend sẽ đọc text PDF -> dịch -> xuất DOCX.
      // Không cần mở modal chọn kiểu xử lý PDF.
      if (isFree) {
        handleCreate(EnumPdfType.Only_Text);
        return;
      }

      // PDF trả phí mới cho chọn chế độ xử lý PDF.
      setPdfType(EnumPdfType.Only_Text);
      setShowPdfTypeModal(true);
      return;
    }

    handleCreate();
  };

  const GetFileHistoryTranslate = async (id: string) => {
    const res = await PaymentService.GetFileHistoryTranslate(id);

    if (res.success) {
      await downloadUrlFile(res.data.fileDownloadBase64, res.data.fileName);
      toast(res.message, "success");
    } else {
      toast(res.message, "error");
    }
  };

  const downloadUrlFile = async (fileUrl: string, fileName?: string) => {
    const finalUrl = buildFileUrl(fileUrl);

    if (!finalUrl) {
      toast(t("file.downloadUrlNotFound"), "error");
      return;
    }

    try {
      const response = await fetch(finalUrl);

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || "translated-file";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // Fallback nếu bị CORS hoặc server không cho fetch trực tiếp
      window.open(finalUrl, "_blank");
    }
  };

  const buildFileUrl = (path?: string) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const baseUrl = envConfig.API_ENDPOINT.replace(/\/api\/?$/i, "").replace(
      /\/$/g,
      "",
    );

    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return encodeURI(`${baseUrl}${cleanPath}`);
  };

  const buildPreviewImageUrl = (path?: string) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const baseUrl = envConfig.API_ENDPOINT.replace(/\/api\/?$/i, "").replace(
      /\/$/g,
      "",
    );

    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return encodeURI(`${baseUrl}${cleanPath}`);
  };

  const handleApplyDiscount = async () => {
    if (!previewFile || !discountCode.trim()) return;

    const data: DiscountCodeRq = {
      code: discountCode.trim(),
      historyTranslateId: previewFile.id,
      rollback: isApplyingDiscount,
    };

    const res = await DiscountService.approveDiscountCode(data);

    if (!res.success) {
      toast(t("discount.invalidCode"), "error");
      return;
    }

    if (res.data.type === "Rollback") {
      setPreviewFile((currentFile) =>
        currentFile
          ? {
              ...currentFile,
              price: res.data.price,
            }
          : currentFile,
      );

      setIsApplyingDiscount(false);

      toast(t("discount.rollbackSuccess"), "success");
      return;
    }

    if (res.data.type === "Approve") {
      toast(t("discount.alreadyUsed"), "info");
      return;
    }

    if (res.data.type === "Success") {
      setPreviewFile((currentFile) =>
        currentFile
          ? {
              ...currentFile,
              price: res.data.price,
            }
          : currentFile,
      );

      setIsApplyingDiscount(true);

      toast(t("discount.applySuccess"), "success");
    }
  };

  return (
    <>
      <Helmet>
        {/* ===== BASIC SEO ===== */}
        <title>
          {commonPageSeo?.page?.title || "Dịch tài liệu online | MikoTech"}
        </title>

        <meta
          name="description"
          content={
            commonPageSeo?.seo?.description ||
            "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh."
          }
        />

        <meta
          name="keywords"
          content={
            commonPageSeo?.seo?.keywords ||
            "dịch tài liệu, dịch file pdf, dịch tiếng anh"
          }
        />

        {/* <link rel="icon" href="/logo/Logo-D-docme.vn-2026.png" /> */}

        <meta name="author" content={commonPageSeo?.seo?.author} />
        {/* <meta name="robots" content="index, follow" /> */}
        <meta
          name="robots"
          content={
            commonPageSeo?.seo?.noIndex ? "noindex, nofollow" : "index, follow"
          }
        />
        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href={
            commonPageSeo?.seo?.canonical
              ? commonPageSeo?.seo?.canonical
              : "https://docme.vn" + commonPageSeo?.page.url
          }
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta property="og:type" content={commonPageSeo?.seo?.og_type} />
        <meta
          property="og:site_name"
          content={commonPageSeo?.seo?.og_site_name}
        />
        <meta property="og:title" content={commonPageSeo?.seo?.og_title} />
        <meta
          property="og:description"
          content={commonPageSeo?.seo?.og_description}
        />
        <meta
          property="og:url"
          content={commonPageSeo?.seo?.og_url || "https://docme.vn/"}
        />
        <meta property="og:image" content={commonPageSeo?.seo?.og_image_alt} />
        <meta
          property="og:image:width"
          content={commonPageSeo?.seo?.og_image_width}
        />
        <meta
          property="og:image:height"
          content={commonPageSeo?.seo?.og_image_height}
        />
        <meta property="og:locale" content={commonPageSeo?.seo?.og_locale} />

        <meta name="twitter:card" content={commonPageSeo?.seo?.twitter_card} />
        <meta
          name="twitter:title"
          content={commonPageSeo?.seo?.twitter_title}
        />
        <meta
          name="twitter:description"
          content={commonPageSeo?.seo?.twitter_description}
        />
        <meta
          name="twitter:image"
          content={commonPageSeo?.seo?.twitter_image}
        />

        {/* ===== CONTACT / BUSINESS INFO ===== */}
        {commonPageSeo?.seo?.schema && (
          <div
            dangerouslySetInnerHTML={{ __html: commonPageSeo?.seo?.schema }}
          />
        )}
      </Helmet>

      <Hero>
        <HeroTitle>{t("hero.title")}</HeroTitle>
        <HeroDescription>{t("hero.description")}</HeroDescription>
      </Hero>

      {/* TABS */}
      {/* <div style={{ textAlign: "center" }}>
        <Tabs>
          <TabButton
            active={tab === "translate"}
            onClick={() => setTab("translate")}>
            Dịch ngôn ngữ
          </TabButton>
          <TabButton active={tab === "file"} onClick={() => setTab("file")}>
            <svg
              width={24}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            {t("tabs.translate")}
          </TabButton>
          <TabButton
          //active={tab === "compress"}
          //onClick={() => setTab("compress")}
          >
            {t("tabs.compress")}
          </TabButton>
        </Tabs>
      </div> */}

      {/* {tab === "translate" && (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 24,
              marginTop: 32,
            }}>
            <TextArea
              placeholder="Nhập văn bản cần dịch..."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <TextArea readOnly placeholder="Bản dịch..." />
          </div>
        </>
      )} */}
      <Box
        sx={{
          display: user ? "block" : "none",
          mt: 1.5,
          p: 1.5,
          border: "1px solid #f8d4d4",
          background: "#fef2f2",
          borderRadius: "12px",
          color: "#000000",
          fontSize: "15px",
          lineHeight: 1.5,
        }}>
        <b>
          <i>
            {t("note.review_note_before")}{" "}
            <span style={{ color: "red" }}>
              {Math.max(
                (commonPageSeo?.seo?.totalNumberOfTranslationServicesUsed ??
                  0) -
                  (commonPageSeo?.seo?.numberOfTranslationServicesUsed ?? 0),
                0,
              )}{" "}
            </span>
            {t("note.review_note_after")}
          </i>
        </b>
      </Box>

      <SectionMain>
        {tab === "file" && (
          <>
            <SectionHeader>
              <SectionTitle>{t("file.section_title")}</SectionTitle>
              <SectionDescription>
                {t("file.section_description")}
              </SectionDescription>
            </SectionHeader>

            <FormGroup>
              <LanguageRow>
                <Label>{t("file.from_language")}</Label>

                <SelectWrapper>
                  <Select
                    value={fromLang}
                    onChange={(e) => setFromLang(e.target.value)}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = "none";
                      e.currentTarget.style.boxShadow = "none";
                    }}>
                    {languages.map((l) => (
                      <option key={l.code} value={l.code}>
                        {l.label}
                      </option>
                    ))}
                  </Select>

                  <SelectArrow>
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </SelectArrow>
                </SelectWrapper>
              </LanguageRow>

              <BtnSwap onClick={handleSwapLanguage}>
                <svg
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"></path>
                </svg>
              </BtnSwap>

              <LanguageRow>
                <Label>{t("file.to_language")}</Label>
                <SelectWrapper>
                  <Select
                    value={toLang}
                    onChange={(e) => setToLang(e.target.value)}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = "none";
                      e.currentTarget.style.boxShadow = "none";
                    }}>
                    {languages.map((l) => (
                      <option key={l.code} value={l.code}>
                        {l.label}
                      </option>
                    ))}
                  </Select>

                  <SelectArrow>
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </SelectArrow>
                </SelectWrapper>
              </LanguageRow>
            </FormGroup>

            <UploadArea
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                border: isDragging
                  ? "2px dashed #2563eb"
                  : "2px dashed #e5e7eb",
                backgroundColor: isDragging ? "#eff6ff" : "#ffffff",
                transition: "all 0.2s ease",
              }}>
              <UploadIcon>
                <UploadSvg
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                </UploadSvg>
              </UploadIcon>
              <FeatureP style={{ fontSize: 18, fontWeight: 500 }}>
                {t("file.drag_text")}{" "}
              </FeatureP>
              <UploadButton
                isDisabled={
                  files.length > 0 || isCountingCharacters || isTranslating
                }>
                <img
                  style={{ filter: "invert(1)" }}
                  width={"20px"}
                  src="/icon/1091554.png"
                />
                {t("file.choose_file")}
                <input
                  ref={fileInputRef}
                  disabled={
                    files.length > 0 || isCountingCharacters || isTranslating
                  }
                  type="file"
                  hidden
                  accept=".doc,.docx,.xlsx,.pptx,.pdf"
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    // Dùng đúng cùng một flow với kéo-thả.
                    await handleAddFile(file);
                  }}
                />
              </UploadButton>
              <p
                style={{
                  marginTop: 12,
                  fontSize: 14,
                  color: "#6b7280",
                  marginBottom: 0,
                }}>
                {t("file.support_text")}
              </p>
              <p
                style={{
                  marginTop: 5,
                  fontSize: 14,
                  color: "red",
                  marginBottom: 0,
                }}>
                {t("fileSizeModal.descAfter")}{" "}
                <b>{MAX_UPLOAD_FILE_SIZE_MB} MB</b>.
              </p>

              {/* {files &&
                files.map((f) => {
                  return <FilePreview>{f.file.name}</FilePreview>;
                })} */}
            </UploadArea>

            {files.map((f, i) => {
              const fileName = f.file?.name || f.fileName || "Document";
              const fileSizeText = f.file?.size
                ? `${(f.file.size / 1024 / 1024).toFixed(2)} MB`
                : f.fileSize
                  ? `${(f.fileSize / 1024 / 1024).toFixed(2)} MB`
                  : "";
              const fileExt =
                fileName.split(".").pop()?.toLowerCase() || "file";
              const fileExtLabel = fileExt.toUpperCase().slice(0, 4);

              return (
                <FileBlock key={f.id || i}>
                  <UploadedFileCard>
                    <UploadedFileIcon fileType={fileExt}>
                      <span>{fileExtLabel}</span>
                    </UploadedFileIcon>

                    <UploadedFileMeta>
                      <UploadedFileName title={fileName}>
                        {fileName}
                      </UploadedFileName>
                      <UploadedFileSize>
                        {fileSizeText ? `- ${fileSizeText}` : ""}
                        {typeof f.totalCharacters === "number" && (
                          <>
                            {fileSizeText ? " · " : ""}
                            {f.totalCharacters.toLocaleString("vi-VN")} ký tự
                          </>
                        )}
                      </UploadedFileSize>
                    </UploadedFileMeta>

                    <UploadedFileActions>
                      {f.previewBase64 && (
                        <UploadedPreviewButton
                          type="button"
                          onClick={() => handlePreviewFileModal(f)}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                          Preview
                        </UploadedPreviewButton>
                      )}

                      <UploadedDeleteButton
                        type="button"
                        onClick={() => {
                          setFiles((prev) =>
                            prev.filter((_, idx) => idx !== i),
                          );

                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }

                          setIsFree(true);
                        }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16">
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                        {t("common.delete")}
                      </UploadedDeleteButton>
                    </UploadedFileActions>
                  </UploadedFileCard>

                  {validTones.length > 0 && (
                    <ToneAnimatedWrapper open={!isFree}>
                      <div className="tone-inner">
                        <ToneSectionTitle>
                          {t("translate.selectTone")}
                        </ToneSectionTitle>

                        <ToneListCard>
                          {validTones.map((l, index) => {
                            const isChecked =
                              toneId === l.id || (!toneId && index === 0);
                            const toneType =
                              toneStyleTypes[index % toneStyleTypes.length];

                            return (
                              <ToneChoice
                                key={l.id}
                                htmlFor={`tone-${l.id}`}
                                selected={isChecked}>
                                <input
                                  type="radio"
                                  id={`tone-${l.id}`}
                                  name="tone"
                                  value={l.id}
                                  checked={isChecked}
                                  onChange={() => setToneId(l.id)}
                                />
                                <span className="radio-dot" />
                                <ToneChoiceIcon className={`tone-${toneType}`}>
                                  {toneIcons[index % toneIcons.length]}
                                </ToneChoiceIcon>
                                <ToneChoiceText>{l.question}</ToneChoiceText>
                              </ToneChoice>
                            );
                          })}
                        </ToneListCard>
                      </div>
                    </ToneAnimatedWrapper>
                  )}

                  {showProcessModal && processFile && (
                    <PreviewOverlay
                      style={{
                        background: "rgba(15, 23, 42, 0.62)",
                        backdropFilter: "blur(8px)",
                      }}>
                      <ProcessModal>
                        <PreviewHeader
                          style={{
                            borderBottom: "none",
                            paddingBottom: 0,
                            position: "relative",
                            justifyContent: "center",
                          }}>
                          <PreviewTitle
                            style={{
                              textAlign: "center",
                              fontSize: 20,
                              fontWeight: 800,
                            }}>
                            {t("file.translating_short")}
                          </PreviewTitle>

                          <CloseButton
                            type="button"
                            aria-label={t("translation.cancelTranslation", {
                              defaultValue: "Hủy dịch",
                            })}
                            disabled={isCancellingTranslation}
                            onClick={handleCancelTranslation}
                            style={{
                              position: "absolute",
                              right: 0,
                              top: -6,
                              opacity: isCancellingTranslation ? 0.55 : 1,
                              cursor: isCancellingTranslation
                                ? "not-allowed"
                                : "pointer",
                            }}>
                            ✕
                          </CloseButton>
                        </PreviewHeader>

                        <PreviewContent
                          style={{
                            marginTop: 18,
                            padding: 0,
                            background: "transparent",
                            maxHeight: "unset",
                            overflow: "visible",
                            textAlign: "center",
                          }}>
                          <ProcessFileCard>
                            <ProcessFileExt>{processFileExt}</ProcessFileExt>

                            <div style={{ minWidth: 0, textAlign: "left" }}>
                              <FileName style={{ maxWidth: 330 }}>
                                {processFileName}
                              </FileName>

                              <FileSize>
                                {processFileSize}
                                {processFileSize ? " · " : ""}
                                {t("translation.processing")}
                              </FileSize>
                            </div>
                          </ProcessFileCard>

                          <ProcessLoader aria-hidden="true">
                            <span />
                            <span />
                            <span />
                            <i />
                          </ProcessLoader>

                          <ProcessText>{getProcessText()}</ProcessText>

                          <ProcessTip>
                            {t("translation.keepThisPageOpen")}
                          </ProcessTip>

                          <ButtonCloseModal
                            type="button"
                            disabled={isCancellingTranslation}
                            onClick={handleCancelTranslation}
                            style={{
                              marginTop: 18,
                              minWidth: 140,
                              opacity: isCancellingTranslation ? 0.65 : 1,
                            }}>
                            {isCancellingTranslation
                              ? t("translation.cancelling", {
                                  defaultValue: "Đang hủy...",
                                })
                              : t("translation.cancelTranslation", {
                                  defaultValue: "Hủy dịch",
                                })}
                          </ButtonCloseModal>
                        </PreviewContent>
                      </ProcessModal>
                    </PreviewOverlay>
                  )}
                </FileBlock>
              );
            })}

            {files.length > 0 && (
              <TermsAgreementBox accepted={acceptedTerms}>
                <TermsAgreementLabel>
                  <TermsAgreementIcon>
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
                      <path d="m9 12 2 2 4-5" />
                    </svg>
                  </TermsAgreementIcon>

                  <input
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={(e) =>
                      handleAcceptedTermsChange(e.target.checked)
                    }
                  />

                  <TermsText>
                    <Trans
                      i18nKey="translate.terms"
                      components={{
                        termsLink: (
                          <a
                            href={
                              envConfig.KEY_BASE === "vn"
                                ? "https://docme.vn/chinh-sach-dieu-khoan-su-dung"
                                : "https://docme.world/policies-terms-of-use"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          />
                        ),
                      }}
                    />
                  </TermsText>
                </TermsAgreementLabel>
              </TermsAgreementBox>
            )}

            {files.length > 0 && hasTranslationModeFile() && (
              <div
                style={{
                  maxWidth: 650,
                  margin: "24px auto 0",
                  padding: 16,
                  border: "1px solid #e5e7eb",
                  borderRadius: 14,
                  background: "#f8fafc",
                }}>
                <div
                  style={{
                    marginBottom: 12,
                    textAlign: "center",
                    fontSize: 15,
                    fontWeight: 700,
                    color: "#0f172a",
                  }}>
                  {t("translationMode.title")}
                </div>

                <TranslationModeGrid>
                  <TranslationModeOption
                    selected={isFree}
                    variantType="free"
                    disabled={
                      hasFileOverFreeLimit() ||
                      Math.max(
                        (commonPageSeo?.seo
                          ?.totalNumberOfTranslationServicesUsed ?? 0) -
                          (commonPageSeo?.seo
                            ?.numberOfTranslationServicesUsed ?? 0),
                        0,
                      ) === 0
                    }>
                    <input
                      className="btn-translateFree"
                      style={{ marginTop: 6 }}
                      disabled={
                        hasFileOverFreeLimit() ||
                        Math.max(
                          (commonPageSeo?.seo
                            ?.totalNumberOfTranslationServicesUsed ?? 0) -
                            (commonPageSeo?.seo
                              ?.numberOfTranslationServicesUsed ?? 0),
                          0,
                        ) === 0
                      }
                      type="radio"
                      name="translationPriceType"
                      checked={isFree}
                      onChange={() => setIsFree(true)}
                    />

                    <span style={{ textAlign: "left" }}>
                      <b className="mode-title" style={{ display: "block" }}>
                        {t("translationMode.free.title")}
                      </b>

                      <small style={{ fontSize: 12 }} className="mode-desc">
                        {t("translationMode.free.desc")}
                      </small>
                    </span>
                  </TranslationModeOption>

                  <TranslationModeOption selected={!isFree} variantType="paid">
                    <input
                      className="btn-translatePaid"
                      style={{ marginTop: 6 }}
                      type="radio"
                      name="translationPriceType"
                      checked={!isFree}
                      onChange={() => setIsFree(false)}
                    />
                    <span style={{ textAlign: "left" }}>
                      <b style={{ display: "block", color: "#111827" }}>
                        {t("translationMode.paid.title")}
                      </b>
                      <small style={{ color: "red", fontSize: 12 }}>
                        {t("translationMode.paid.desc")}
                      </small>
                    </span>
                  </TranslationModeOption>
                </TranslationModeGrid>
              </div>
            )}

            <div
              style={{
                textAlign: "center",
                marginTop: 24,
                marginBottom: "24px",
              }}>
              <TranslateNowButton
                type="button"
                className="TranslateNowButton"
                onClick={handleTranslateClick}
                style={{
                  background: isCountingCharacters
                    ? "linear-gradient(135deg, #9333ea 0%, #2563eb 100%)"
                    : "",
                }}
                disabled={
                  !user ||
                  isCountingCharacters ||
                  isTranslating ||
                  !files.length ||
                  !acceptedTerms
                }>
                {isCountingCharacters ? (
                  <LoadingButtonContent>
                    <Spinner />
                    <LoadingText>
                      {t("file.reading_file", {
                        defaultValue: "Đang đọc tài liệu...",
                      })}
                    </LoadingText>
                  </LoadingButtonContent>
                ) : isTranslating ? (
                  <LoadingButtonContent>
                    <Spinner />
                    <LoadingText>{t("file.translating")}</LoadingText>
                  </LoadingButtonContent>
                ) : (
                  <>
                    <img
                      style={{ filter: "invert(1)" }}
                      width={"20px"}
                      src="/icon/ai-file_9812085.png"
                    />{" "}
                    {t("file.translate_now")}
                    {hasTranslationModeFile()
                      ? ` - ${isFree ? t("translationMode.free.short") : t("translationMode.paid.short")}`
                      : ""}
                  </>
                )}
              </TranslateNowButton>
              {/* <TranslateNowButton disabled={!files.length}>Dịch file</TranslateNowButton> */}
            </div>

            <Note>
              {t("note.line1")}
              <br />
              {t("note.line2")}
              <br />
              {t("note.line3")}
              <br />
              {t("note.line4")}
              <br />
              {t("note.line5")}
              <br />
              <p style={{ marginTop: "1rem", fontSize: "13px" }}>
                <i style={{ color: "red" }}>{t("note.warning")}</i>
              </p>
            </Note>

            {/* {isTranslating &&
              files.length > 0 &&
              files.map((f) => {
                return (
                  <WaveProgressWrapper>
                    <WaveTitle>
                      📄 Đang dịch: <b>{f.file.name}</b>
                    </WaveTitle>

                    <WaveProgress>
                      <WaveProgressFill
                        style={{ width: `${progress}%` }}
                        done={progress === 100}
                      />
                    </WaveProgress>

                    <WavePercent>{progress}%</WavePercent>
                  </WaveProgressWrapper>
                );
              })} */}

            {/* {previewBase64 && (
              <div style={{ marginTop: 24 }}>
                <Button onClick={() => setShowPreviewModal(true)}>
                  👁 Preview
                </Button>
              </div>
            )} */}

            {showPreviewModal && (
              <PreviewOverlayPreview>
                <PreviewModal>
                  <PreviewHeader>
                    <PreviewTitle>{t("preview.title")}</PreviewTitle>
                    <CloseButton onClick={closePreviewModal}>✕</CloseButton>
                  </PreviewHeader>

                  <Box sx={{ paddingTop: "10px", fontSize: "15px" }}>
                    <b>
                      <i>
                        {t("note.review_note_before")}{" "}
                        <span style={{ color: "red" }}>
                          {Math.max(
                            (previewFile?.totalNumberOfTranslationServicesUsed ??
                              0) -
                              (previewFile?.numberOfTranslationServicesUsed ??
                                0),
                            0,
                          )}{" "}
                        </span>
                        {t("note.review_note_after")}
                      </i>{" "}
                    </b>
                  </Box>

                  {isFree === false ? (
                    <PreviewContent
                      style={{
                        position: "relative",
                        minHeight: 430,
                      }}>
                      {isRenderingPreview && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "rgba(255,255,255,.92)",
                            backdropFilter: "blur(6px)",
                            zIndex: 999,
                            gap: 24,
                          }}>
                          <div
                            style={{
                              width: 70,
                              height: 70,
                              borderRadius: "50%",
                              border: "5px solid #dbeafe",
                              borderTop: "5px solid #2563eb",
                              animation: "spin 1s linear infinite",
                            }}
                          />

                          <div
                            style={{
                              width: 260,
                              height: 6,
                              background: "#e5e7eb",
                              borderRadius: 999,
                              overflow: "hidden",
                            }}>
                            <div
                              style={{
                                width: "40%",
                                height: "100%",
                                borderRadius: 999,
                                background:
                                  "linear-gradient(90deg,#2563eb,#60a5fa,#2563eb)",
                                animation:
                                  "loadingBar 1.2s infinite ease-in-out",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: "#1e3a8a",
                            }}>
                            {t("preview.loading_title")}
                            <span className="loading-dots">...</span>
                          </div>

                          <div
                            style={{
                              color: "#6b7280",
                              fontSize: 14,
                            }}>
                            {t("preview.loading_desc")}
                          </div>
                        </div>
                      )}

                      <div id="pdf-preview-container">
                        {previewFile?.previewBase64 && (
                          <img
                            src={previewFile.previewBase64}
                            alt={previewFile.fileName || "Preview"}
                            onLoad={() => setIsRenderingPreview(false)}
                            onError={() => {
                              setIsRenderingPreview(false);
                              toast(
                                t("error.preview_fail") ||
                                  t("error.translate_fail"),
                                "error",
                              );
                            }}
                            style={{
                              width: "100%",
                              height: "auto",
                              display: "block",
                              borderRadius: 12,
                              background: "#ffffff",
                            }}
                          />
                        )}
                      </div>
                    </PreviewContent>
                  ) : (
                    <div
                      style={{
                        marginTop: 18,
                        padding: "28px 24px",
                        borderRadius: 16,
                        border: "1px solid #e2e8f0",
                        background:
                          "linear-gradient(135deg, #f8fafc 0%, #ffffff 55%, #f5f3ff 100%)",
                        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
                      }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 18,
                          padding: "18px 20px",
                          borderRadius: 14,
                          background: "#ffffff",
                          border: "1px solid #e5e7eb",
                          boxShadow: "0 8px 22px rgba(15, 23, 42, 0.06)",
                        }}>
                        <UploadedFileIcon
                          fileType={
                            previewFile?.fileName
                              ?.split(".")
                              .pop()
                              ?.toLowerCase() || "file"
                          }>
                          <span>
                            {previewFile?.fileName
                              ?.split(".")
                              .pop()
                              ?.toUpperCase()
                              .slice(0, 4) || "FILE"}
                          </span>
                        </UploadedFileIcon>

                        <div
                          style={{
                            minWidth: 0,
                            flex: 1,
                          }}>
                          <UploadedFileName
                            title={previewFile?.fileName}
                            style={{
                              maxWidth: "100%",
                              marginBottom: 7,
                            }}>
                            {previewFile?.fileName || "Document"}
                          </UploadedFileName>

                          {previewFile?.fileSize ? (
                            <UploadedFileSize
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}>
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <path d="M14 2v6h6" />
                              </svg>

                              {formatFileSizeMB(previewFile.fileSize)}
                            </UploadedFileSize>
                          ) : null}

                          <div
                            style={{
                              marginTop: 10,
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "5px 10px",
                              borderRadius: 999,
                              background: "#ecfdf5",
                              color: "#15803d",
                              fontSize: 12,
                              fontWeight: 600,
                            }}>
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round">
                              <path d="m9 12 2 2 4-4" />
                              <circle cx="12" cy="12" r="9" />
                            </svg>

                            {t("translationMode.free.title")}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <PreviewFooter>
                    <i className="footer-item-i">
                      <img
                        style={{
                          filter:
                            "invert(17%) sepia(96%) saturate(7492%) hue-rotate(358deg) brightness(95%) contrast(112%)",
                        }}
                        width={30}
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADLUlEQVR4nO2YW4hNURjHf2MuucygiJmU5JIXFMIULxMPGl7IpcjgxVAYl7yIBxQKD3gYPLhElIRccsklNSGM3MaDW8gYd7mEGWO2Vv67lm3O6Zyz9z7nqP2r1Tn722t93/r2+tZa31oQERERERERERhtgErgNtAIOCGXJqAOWAzkBecG7ElD550Y5USqzhQBm4DHwFPgghR+BSqAQsKnEJgNfJHtpckqGAA8iPFl5pJ+Zsr2/WQajQI+qOEtYDBQAjRLZkYq3bSX7Z+JVM7R0DWp0XEpcHGypMSlizpuKrYAm1uZWFnvyHDgiSp9AqbEqJe1juQAVVYoXQd6x3E4Kx0pAc5aobQRyI83bInGaIg4XvvjgTcSvtVzSorSjOPabwts1QgYwRmNTNKK4pALlAFbFKr3gJ1AP38+/G3/pv58BxZpjhCQI/nagWNtombk+yRpL6b9Bm1wA0mN1hwpUkL3zHpvUprVQKlG4ojk+1K0+4/9fGWvBOBIMbDWygAcZakzWtl/+uq9qesHJ6g56iraAfywni8B4+KEamfVawrIvi+GeWL+F3AIGJFA2wq1uZNJR3KAY5aSb0C1wiURzAR/obYLyaAjecAr4D2wBuiWRNuRQL2MXwnghOf4Da0OQEES9XvqJOnuV9eArn46wJ+P4IZ06AwBdlm5m/ldB7QLQHepdJplPjTGArXW0Ddrz+gfgO5cLSh10r2BkJhsjUDY5S7QMQwnpuvoGWbnW4DnugTpFIYTlZp4xtgqYJb+H/DUq5Z8gecg5ygvyxgmxVlurUhmSTas0PN6T/2TkpdbsiWSmQ017ZgjwCTgqrUMmtOly37J53na1Ug+2lpGTaw7ypZ9dai7stKhwBhgopSajq3UyrAdOAic0vWody5clL4CJY+u3CSNNuesThu72/Rc72dZvuxj0jWq81W6aTSyl8BnT729SmtMmW+FoONJc8r8jEaNOmSOuY+AG8B54DCwW1dAJuaXAXOAqToGD9JIukwD3lmrSq1uAl0HG3TF6r4/DbwGPgJHpS9rMBtVL6XoLuX6QO6XfwhM4D+mGOjh8xAXERERERERQRx+A1Ns/jikzsHQAAAAAElFTkSuQmCC"
                        alt="card-in-use"></img>{" "}
                      {t("preview.note")}
                    </i>

                    <div className="footer-item-div">
                      {isFree == false ? (
                        <>
                          <TextField
                            sx={{
                              width: "35%",
                              marginLeft: "auto",
                              "& input": {
                                cursor: isApplyingDiscount
                                  ? "not-allowed"
                                  : "text",
                              },
                              // "& .MuiOutlinedInput-root": {
                              //   borderRadius: "8px",
                              //   height: 52,

                              //   "&.Mui-disabled": {
                              //     backgroundColor: "#fff", // hoặc "transparent"
                              //   },

                              //   "&.Mui-disabled fieldset": {
                              //     borderColor: "#d0d5dd",
                              //   },
                              // },

                              // "& .MuiOutlinedInput-input.Mui-disabled": {
                              //   WebkitTextFillColor: "#333", // giữ màu chữ
                              //   color: "#333",
                              //   cursor: "not-allowed",
                              // },
                            }}
                            fullWidth
                            placeholder={t("discount.placeholder")}
                            //disabled={isApplyingDiscount}
                            value={discountCode}
                            onChange={(e) => setDiscountCode(e.target.value)}
                            InputProps={{
                              readOnly: isApplyingDiscount,
                              sx: {
                                borderRadius: "8px",
                                pr: 0.5,
                                height: 52,
                              },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Button
                                    onClick={handleApplyDiscount}
                                    disabled={!discountCode}
                                    sx={{
                                      padding: "12px 10px",
                                      borderRadius: "6px",
                                      height: 40,
                                      textTransform: "none",
                                      fontWeight: 700,
                                    }}>
                                    {isApplyingDiscount ? (
                                      <svg
                                        style={{
                                          color: discountCode
                                            ? "#fff"
                                            : "#000000",
                                        }}
                                        width={"20"}
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 25 25"
                                        fill="none">
                                        <path
                                          d="M5.88468 17C7.32466 19.1128 9.75033 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5V13.5"
                                          stroke="currentColor"
                                          stroke-width="1.2"
                                        />
                                        <path
                                          d="M7 11L4.5 13.5L2 11"
                                          stroke="currentColor"
                                          stroke-width="1.2"
                                        />
                                      </svg>
                                    ) : (
                                      <svg
                                        style={{
                                          color: discountCode
                                            ? "#fff"
                                            : "#000000",
                                        }}
                                        width={"30"}
                                        xmlns="http://www.w3.org/2000/svg"
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        viewBox="0 0 122.88 66.32">
                                        <title>voucher</title>
                                        <path
                                          fill="currentColor"
                                          d="M31.74,27.23a2.86,2.86,0,0,0,5.68.44,3.25,3.25,0,0,0,0-.44V21.52a2.86,2.86,0,0,0-5.68-.44,3.25,3.25,0,0,0,0,.44v5.71ZM5.76,0H117.12a5.77,5.77,0,0,1,5.76,5.76V12a2.36,2.36,0,0,1-2.35,2.36l-.34,0h0a6.27,6.27,0,0,0-4.46,1.87,6.48,6.48,0,0,0-1.9,4.52v.16a6.37,6.37,0,0,0,1.92,4.55l.11.11a6.67,6.67,0,0,0,4.55,1.73h.11a2.34,2.34,0,0,1,2.35,2.33h0v7.9a2.35,2.35,0,0,1-2.35,2.35h-.12a6.65,6.65,0,0,0-4.64,1.84h0a6.38,6.38,0,0,0-1.93,4.53v.16a6.53,6.53,0,0,0,1.9,4.53,6.29,6.29,0,0,0,4.46,1.87h.31a2.34,2.34,0,0,1,2.37,2.31v0h0v5.35a5.74,5.74,0,0,1-1.69,4.07l-.17.15a5.71,5.71,0,0,1-3.9,1.55H5.76A5.77,5.77,0,0,1,1.7,64.63h0A5.78,5.78,0,0,1,0,60.55V55.2a2.35,2.35,0,0,1,2.35-2.35h.33A6.31,6.31,0,0,0,7.15,51a6.52,6.52,0,0,0,1.9-4.52v-.08H9a6.45,6.45,0,0,0-6.46-6.47A2.35,2.35,0,0,1,.23,37.57L0,29.74a2.34,2.34,0,0,1,2.28-2.41h.18a6.65,6.65,0,0,0,4.66-1.83l.11-.1a6.36,6.36,0,0,0,1.81-4.45v-.17a6.34,6.34,0,0,0-1.92-4.54L7,16.12A6.66,6.66,0,0,0,2.47,14.4l-.25,0A2.33,2.33,0,0,1,0,12.05H0V5.76A5.77,5.77,0,0,1,1.69,1.7h0A5.77,5.77,0,0,1,5.76,0ZM70.17,47.15a3.84,3.84,0,0,1-1.51,1.48,7.05,7.05,0,0,1-3.19.53c-1.49,0-2.24-.4-2.24-1.19a1.47,1.47,0,0,1,.09-.36L79.48,19a8.24,8.24,0,0,1,.75-1.12,3.76,3.76,0,0,1,1.26-.77,5.83,5.83,0,0,1,2.28-.39c1.89,0,2.83.41,2.83,1.23a.88.88,0,0,1-.09.41L70.17,47.15Zm-7.39-13a15,15,0,0,1-3.5-.36,8.08,8.08,0,0,1-2.76-1.28q-2.6-1.87-2.6-7.26t2.74-7a11.14,11.14,0,0,1,6.12-1.5,11.54,11.54,0,0,1,6.16,1.5c1.82,1.19,2.74,3.53,2.74,7s-.87,6-2.61,7.26a10.89,10.89,0,0,1-6.29,1.64Zm0-4.43a.74.74,0,0,0,.59-.27c.39-.43.59-1.51.59-3.24a23.31,23.31,0,0,0-.18-3.58,2.66,2.66,0,0,0-.41-1.21.77.77,0,0,0-.59-.23c-.8,0-1.19,1.42-1.19,4.27s.39,4.26,1.19,4.26Zm24,19.9a15,15,0,0,1-3.49-.36A7.89,7.89,0,0,1,80.53,48q-2.59-1.87-2.6-7.26c0-3.5.91-5.82,2.74-7a10.87,10.87,0,0,1,6.11-1.55A11.29,11.29,0,0,1,93,33.73c1.82,1.16,2.73,3.48,2.73,7s-.86,6-2.6,7.26a10.83,10.83,0,0,1-6.3,1.64Zm0-4.42a.83.83,0,0,0,.6-.23c.39-.46.59-1.55.59-3.29a23.4,23.4,0,0,0-.18-3.58,2.71,2.71,0,0,0-.41-1.21.83.83,0,0,0-.6-.23c-.79,0-1.18,1.42-1.18,4.27s.39,4.27,1.18,4.27ZM117.12,4.71H37.45v5.38a3,3,0,0,1,0,.43,2.86,2.86,0,0,1-5.68-.43V4.71h-26A1,1,0,0,0,5,5H5a1,1,0,0,0-.3.74V9.9a11.34,11.34,0,0,1,5.53,2.82l.15.13a11,11,0,0,1,3.35,7.88V21a11,11,0,0,1-3.21,7.72l-.14.15A11.21,11.21,0,0,1,4.76,31.8l.11,3.65a11.16,11.16,0,0,1,5.61,3,11.13,11.13,0,0,1,3.27,7.9s0,.09,0,.12a11.19,11.19,0,0,1-3.26,7.79,11.06,11.06,0,0,1-5.77,3.07v3.18a1,1,0,0,0,.3.75H5a1.06,1.06,0,0,0,.74.3h26v-5.8a3,3,0,0,1,0-.43,2.86,2.86,0,0,1,5.68.43v5.8h79.67a1,1,0,0,0,.67-.24l.07-.07a1.07,1.07,0,0,0,.31-.75V57.36a11,11,0,0,1-5.77-3.06,11.16,11.16,0,0,1-3.26-7.78v-.27a11,11,0,0,1,3.37-7.87,11.3,11.3,0,0,1,5.66-3V31.8a11.19,11.19,0,0,1-5.53-2.8l-.15-.13A11,11,0,0,1,109.14,21v-.28A11.18,11.18,0,0,1,112.4,13a11,11,0,0,1,5.77-3.08V5.76a1.06,1.06,0,0,0-1-1ZM31.74,44.38a2.86,2.86,0,0,0,5.68.44,3.25,3.25,0,0,0,0-.44V38.67a2.86,2.86,0,0,0-5.68-.44,3.15,3.15,0,0,0,0,.44v5.71Z"
                                        />
                                      </svg>
                                    )}
                                  </Button>
                                </InputAdornment>
                              ),
                            }}
                          />

                          <ButtonPaymentModal
                            className="ButtonPayment"
                            onClick={() => setShowPaymentModal(true)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              strokeWidth="0.8"
                              className="bi bi-credit-card"
                              viewBox="0 0 16 16">
                              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                              <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
                            </svg>
                            {t("preview.payment")}{" "}
                            {envConfig.KEY_BASE === "vn"
                              ? previewFile?.price &&
                                formatVND(previewFile?.price) + " VNĐ"
                              : previewFile?.price && previewFile?.price + " $"}
                          </ButtonPaymentModal>
                        </>
                      ) : (
                        <>
                          <ButtonSaveFileModal
                            onClick={() => {
                              previewFile &&
                                GetFileHistoryTranslate(previewFile?.id);
                            }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.8"
                              className="bi bi-download">
                              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                            </svg>
                            {t("preview.download")}
                          </ButtonSaveFileModal>
                        </>
                      )}

                      <ButtonCloseModal onClick={closePreviewModal}>
                        {t("common.close")}
                      </ButtonCloseModal>
                    </div>
                  </PreviewFooter>
                </PreviewModal>
              </PreviewOverlayPreview>
            )}

            {showPaymentModal && (
              <PreviewOverlay>
                <PreviewModal style={{ maxWidth: 420 }}>
                  <PreviewHeader>
                    <PreviewTitle>
                      {t("preview.choose_payment_method")}
                    </PreviewTitle>
                    <CloseButton onClick={() => setShowPaymentModal(false)}>
                      ✕
                    </CloseButton>
                  </PreviewHeader>

                  <PreviewContent
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 16,
                      padding: 20,
                    }}>
                    {envConfig.KEY_BASE === "vn" ? (
                      <>
                        {/* VietQR */}
                        <ButtonPaymentModal
                          className="ButtonVnpayPayment"
                          sx={{ justifyContent: "center" }}
                          onClick={() => {
                            setShowPaymentModal(false);
                            handleGetQrcode();
                          }}>
                          <img
                            style={{
                              height: "20px",
                              filter: "drop-shadow(0px 1px 1px white)",
                            }}
                            src="/icon/VietQR.46a78cbb.png"
                          />{" "}
                          🇻🇳 VietQR
                        </ButtonPaymentModal>
                      </>
                    ) : (
                      <>
                        {/* PayPal */}
                        <div
                          style={{ marginTop: 10 }}
                          className="ButtonPayPalPayment">
                          <PayPalButtons
                            style={{ layout: "vertical" }}
                            createOrder={() =>
                              createOrder(
                                previewFile?.orderId,
                                previewFile?.price,
                              )
                            }
                            onApprove={(data) =>
                              onApprove(data, previewFile?.orderId)
                            }
                          />
                        </div>
                      </>
                    )}
                  </PreviewContent>
                </PreviewModal>
              </PreviewOverlay>
            )}

            {showPdfTypeModal && (
              <PreviewOverlay>
                <PreviewModal style={{ maxWidth: 520 }}>
                  <PreviewHeader>
                    <PreviewTitle>
                      {t("pdf.selectPdfTranslationMode")}
                    </PreviewTitle>
                    <CloseButton onClick={() => setShowPdfTypeModal(false)}>
                      ✕
                    </CloseButton>
                  </PreviewHeader>

                  <PreviewContent
                    style={{
                      background: "#ffffff",
                      display: "flex",
                      flexDirection: "column",
                      gap: 14,
                      padding: 20,
                    }}>
                    <div style={{ fontSize: 14, color: "#4b5563" }}>
                      {t("pdf.selectPdfProcessingModeBeforeStart")}{" "}
                    </div>

                    {pdfTypeOptions.map((option) => (
                      <RadioButton
                        key={option.value}
                        onClick={() => setPdfType(option.value)}
                        style={{
                          alignItems: "center",
                          padding: "12px",
                          border:
                            pdfType === option.value
                              ? "1px solid #2563eb"
                              : "1px solid #e5e7eb",
                          borderRadius: 10,
                          background:
                            pdfType === option.value ? "#eff6ff" : "#ffffff",
                          cursor: "pointer",
                        }}>
                        <input
                          type="radio"
                          id={`pdf-type-${option.value}`}
                          name="pdfType"
                          value={option.value}
                          checked={pdfType === option.value}
                          onChange={() => setPdfType(option.value)}
                        />

                        <label htmlFor={`pdf-type-${option.value}`}></label>

                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                            cursor: "pointer",
                            flex: 1,
                            fontSize: 14,
                            color: "#334155",
                          }}>
                          <b style={{ color: "#111827" }}>{option.title}</b>
                          <small style={{ color: "red", lineHeight: 1.4 }}>
                            {option.desc}
                          </small>
                        </span>
                      </RadioButton>
                    ))}
                  </PreviewContent>

                  <PreviewFooter
                    style={{ justifyContent: "center", alignItems: "center" }}>
                    <div style={{ display: "flex", gap: 8 }}>
                      <ButtonPaymentModal
                        onClick={() => {
                          setShowPdfTypeModal(false);
                          handleCreate(pdfType);
                        }}
                        disabled={isTranslating}>
                        {t("common.ok")}
                      </ButtonPaymentModal>

                      <ButtonCloseModal
                        onClick={() => setShowPdfTypeModal(false)}
                        disabled={isTranslating}>
                        {t("common.close")}
                      </ButtonCloseModal>
                    </div>
                  </PreviewFooter>
                </PreviewModal>
              </PreviewOverlay>
            )}
          </>
        )}

        {showCharacterLimitModal && (
          <PreviewOverlay>
            <PreviewModal style={{ maxWidth: 480 }}>
              <PreviewHeader>
                <PreviewTitle>
                  {t("characterLimitModal.title", {
                    defaultValue: "Vượt quá giới hạn dịch miễn phí",
                  })}
                </PreviewTitle>

                <CloseButton
                  onClick={() => {
                    setShowCharacterLimitModal(false);
                    setCharacterLimitFile(null);
                    setCharacterLimitCount(0);
                  }}>
                  ✕
                </CloseButton>
              </PreviewHeader>

              <PreviewContent
                style={{
                  background: "#ffffff",
                  padding: 24,
                  textAlign: "center",
                }}>
                <div
                  style={{
                    width: 72,
                    height: 72,
                    margin: "0 auto 16px",
                    borderRadius: "50%",
                    background: "#fff7ed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ea580c",
                  }}>
                  <svg
                    width="38"
                    height="38"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                  </svg>
                </div>

                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: "#111827",
                    marginBottom: 8,
                  }}>
                  {t("characterLimitModal.heading", {
                    defaultValue: "Tệp vượt quá 30.000 ký tự",
                  })}
                </div>

                <div
                  style={{
                    color: "#4b5563",
                    fontSize: 15,
                    lineHeight: 1.6,
                  }}>
                  {t("characterLimitModal.descBefore", {
                    defaultValue: "Tệp của bạn có",
                  })}{" "}
                  <b style={{ color: "#dc2626" }}>
                    {characterLimitCount.toLocaleString("vi-VN")}{" "}
                    {t("characterLimitModal.characters", {
                      defaultValue: "ký tự",
                    })}
                  </b>
                  ,{" "}
                  {t("characterLimitModal.descAfter", {
                    defaultValue:
                      "vượt quá giới hạn 10.000 ký tự cho phép dịch miễn phí. Hệ thống đã tự động chuyển tệp sang chế độ dịch trả phí.",
                  })}
                </div>

                {characterLimitFile?.name && (
                  <div
                    style={{
                      marginTop: 14,
                      padding: "10px 12px",
                      borderRadius: 10,
                      background: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      color: "#374151",
                      fontSize: 14,
                      wordBreak: "break-word",
                    }}>
                    {characterLimitFile.name}
                  </div>
                )}
              </PreviewContent>

              <PreviewFooter style={{ justifyContent: "center" }}>
                <ButtonCloseModal
                  onClick={() => {
                    setShowCharacterLimitModal(false);
                    setCharacterLimitFile(null);
                    setCharacterLimitCount(0);
                  }}>
                  {t("characterLimitModal.confirm", {
                    defaultValue: "Đã hiểu",
                  })}
                </ButtonCloseModal>
              </PreviewFooter>
            </PreviewModal>
          </PreviewOverlay>
        )}

        {showFileSizeModal && (
          <PreviewOverlay>
            <PreviewModal style={{ maxWidth: 460 }}>
              <PreviewHeader>
                <PreviewTitle>{t("fileSizeModal.title")}</PreviewTitle>

                <CloseButton
                  onClick={() => {
                    setShowFileSizeModal(false);
                    setRejectedLargeFile(null);
                  }}>
                  ✕
                </CloseButton>
              </PreviewHeader>

              <PreviewContent
                style={{
                  background: "#ffffff",
                  padding: 24,
                  textAlign: "center",
                }}>
                <div
                  style={{
                    width: 72,
                    height: 72,
                    margin: "0 auto 16px",
                    borderRadius: "50%",
                    background: "#fef2f2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#dc2626",
                  }}>
                  <svg
                    width="38"
                    height="38"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                  </svg>
                </div>

                <div
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    color: "#111827",
                    marginBottom: 8,
                  }}>
                  {t("fileSizeModal.heading")}
                </div>

                <div
                  style={{
                    color: "#4b5563",
                    fontSize: 15,
                    lineHeight: 1.6,
                  }}>
                  {t("fileSizeModal.descBefore")}{" "}
                  <b style={{ color: "#dc2626" }}>
                    {rejectedLargeFile
                      ? formatFileSizeMB(rejectedLargeFile.size)
                      : ""}
                  </b>
                  . {t("fileSizeModal.descAfter")}{" "}
                  <b>{MAX_UPLOAD_FILE_SIZE_MB} MB</b>.
                </div>

                {rejectedLargeFile?.name && (
                  <div
                    style={{
                      marginTop: 14,
                      padding: "10px 12px",
                      borderRadius: 10,
                      background: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      color: "#374151",
                      fontSize: 14,
                      wordBreak: "break-word",
                    }}>
                    {rejectedLargeFile.name}
                  </div>
                )}
              </PreviewContent>

              <PreviewFooter style={{ justifyContent: "center" }}>
                <ButtonCloseModal
                  onClick={() => {
                    setShowFileSizeModal(false);
                    setRejectedLargeFile(null);
                  }}>
                  {t("fileSizeModal.confirm")}
                </ButtonCloseModal>
              </PreviewFooter>
            </PreviewModal>
          </PreviewOverlay>
        )}

        <Features>
          <FeatureItem>
            <FeatureIcon>📄</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.format.title")}</FeatureH4>
              <FeatureP>{t("feature.format.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>

          <FeatureItem>
            <FeatureIcon>🔒</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.security.title")}</FeatureH4>
              <FeatureP>{t("feature.security.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>

          <FeatureItem>
            <FeatureIcon>✨</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.layout.title")}</FeatureH4>
              <FeatureP>{t("feature.layout.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>
        </Features>
      </SectionMain>

      <DocumentNoteWrapper
        dangerouslySetInnerHTML={{
          __html:
            i18n.language === "VI"
              ? commonPageSeo?.seo?.content
                ? commonPageSeo?.seo?.content.replace(/&nbsp;/g, " ")
                : ""
              : i18n.language === "EN"
                ? commonPageSeo?.seo?.content_en
                  ? commonPageSeo?.seo?.content_en.replace(/&nbsp;/g, " ")
                  : ""
                : i18n.language === "ID"
                  ? commonPageSeo?.seo?.content_indo
                    ? commonPageSeo?.seo?.content_indo.replace(/&nbsp;/g, " ")
                    : ""
                  : i18n.language === "TH"
                    ? commonPageSeo?.seo?.content_th
                      ? commonPageSeo?.seo?.content_th.replace(/&nbsp;/g, " ")
                      : ""
                    : "",
        }}
      />
      {/* 
      {commonPageSeo?.faqs && commonPageSeo?.faqs.length > 0 && (
        <FAQ faqs={commonPageSeo?.faqs} />
      )} */}
    </>
  );
};

export default AiToolsPage;
